<script setup lang="ts">
import { computed } from 'vue'
import BaseSvgIcon from '@/components/Base/SvgIcon.vue'
import { usePullToRefresh } from '@/composables/usePullToRefresh'

const state = usePullToRefresh()
const isActive = computed(() => state.isActive.value)
const isRefreshing = computed(() => state.isRefreshing.value)
const blockHeight = computed(() => `${state.pullDistance.value}px`)
</script>

<template>
  <Teleport to="body">
    <div
      v-if="isActive"
      class="pull-refresh-indicator"
      :style="{ height: blockHeight }"
    >
      <BaseSvgIcon
        iconName="refresh"
        :class="{ 'pull-refresh-indicator__icon--spinning': isRefreshing }"
      />
    </div>
  </Teleport>
</template>

<style scoped lang="scss">
.pull-refresh-indicator {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: $--color-white;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: $--swipe-back-indicator-z-index; // 沿用既有最高層級的 z-index 變數，不用再新增一個

  &__icon--spinning {
    animation: pull-refresh-spin 0.8s linear infinite;
  }
}

@keyframes pull-refresh-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
